var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-image",attrs:{"id":"app"}},[_c('header-section'),_c('div',{staticClass:"flex overflow-hidden w-3/4 mx-auto"},[_c('sidebar-menu'),_c('content-area',[_c('router-view')],1)],1),_c('footer-section')],1)}
var staticRenderFns = []

export { render, staticRenderFns }